export const renderTooltipChecklist = (
  checklist: { label: string; success: boolean }[],
) => checklist.map(item => <div>{item.label}</div>);
